import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    alignItems: 'flex-end',
    fontSize: theme.typography.body2.fontSize,
  },
  labraText: {
    fontSize: '1.125rem',
    color: theme.palette.black.dark,
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'flex-end',
  },
  labraImage: {
    marginLeft: theme.spacing(1.6875),
    width: '42px',
    marginRight: theme.spacing(0.25),
  },
}))
